function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Error_svg__6_c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F06A57"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#DE2612"
})), React.createElement("filter", {
  id: "Error_svg__4_a",
  width: "123.1%",
  height: "123.1%",
  x: "-11.5%",
  y: "-11.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  "in": "SourceAlpha",
  radius: 6,
  result: "shadowSpreadInner1"
}), React.createElement("feOffset", {
  "in": "shadowSpreadInner1",
  result: "shadowOffsetInner1"
}), React.createElement("feComposite", {
  "in": "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), React.createElement("feColorMatrix", {
  "in": "shadowInnerInner1",
  values: "0 0 0 0 0.984313725 0 0 0 0 0.866666667 0 0 0 0 0.847058824 0 0 0 1 0"
})), React.createElement("rect", {
  id: "Error_svg__5_b",
  width: 26,
  height: 26,
  x: 0,
  y: 0,
  rx: 13
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#Error_svg__4_a)",
  xlinkHref: "#Error_svg__5_b"
}), React.createElement("path", {
  fill: "url(#Error_svg__6_c)",
  d: "M9 1a8 8 0 017.996 7.75L17 9a8 8 0 01-7.75 7.996L9 17A8 8 0 019 1zm0 10.752a1.25 1.25 0 00-1.244 1.122l-.006.128.006.127a1.25 1.25 0 001.116 1.116l.128.007.128-.007A1.25 1.25 0 009 11.752zM8.174 4l-.084.006c-.192.03-.338.169-.34.335v.02l.38 5.815.013.067c.049.15.215.259.41.257h.893l.082-.006c.185-.028.33-.157.342-.318l.38-5.816-.005-.07c-.031-.158-.194-.283-.397-.29H8.174z",
  transform: "translate(4 4)"
}));

var SvgError = function SvgError(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _ref, _ref2);
};

export default SvgError;